import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  TextField,
  TableCell,
  TableRow,
  TableBody,
  Table,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
  TableContainer,
  TableHead,
  CircularProgress,
  Paper,
  DialogContentText,
} from "@material-ui/core";
import { toast } from "react-toastify";
import { useStore } from "@store/store";
import closeIcon from "@assets/images/close.svg";
import IOSSwitch from '@components/iOSSwitch';
import DeletePopup from "@components/deletePopup";
import {
  GET_ADDITIONAL_CHARGE_TYPE,
  GET_ADDITIONAL_CHARGE_TYPE_SUCCESS,
  GET_ADDITIONAL_CHARGE_TYPE_FAILURE,
  ADD_SURCHARGE,
  ADD_SURCHARGE_SUCCESS,
  ADD_SURCHARGE_FAILURE,
  EDIT_SURCHARGE,
  EDIT_SURCHARGE_SUCCESS,
  EDIT_SURCHARGE_FAILURE,
  DELETE_SURCHARGE,
  DELETE_SURCHARGE_SUCCESS,
  DELETE_SURCHARGE_FAILURE,
  RESTORE_SURCHARGE,
  RESTORE_SURCHARGE_SUCCESS,
  RESTORE_SURCHARGE_FAILURE,
} from "@utils/actionTypes";
import API from "@services/axios";
import { surchargeUpdateStyle } from "./style";
import { utcToTimezone } from "@utils/commonFunctions";
import { timezoneDefault } from "@utils/constant";

function SurchargeUpdate() {
  const classes = surchargeUpdateStyle();
  const [radioValue, setRadioValue] = useState('jobLevel');
  const [surchargeType, setSurchargeType] = useState('');
  const [surchargeTypeError, setSurchargeTypeError] = useState('');
  const [getDeleteSurcharge, setDeleteSurcharge] = useState({});
  const [openDeletePopup, setDeletePopup] = useState(false);
  const [openRestorePopup, setRestorePopup] = useState(false);
  const [open, setOpen] = useState(false);
  const [state, dispatch] = useStore();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // API calling to get additional charge type
  const getAdditionalChargeType = () => {
    dispatch({ type: GET_ADDITIONAL_CHARGE_TYPE });
    API.get("master/additionalChargeTypes")
      .then((response) => {
        dispatch({
          type: GET_ADDITIONAL_CHARGE_TYPE_SUCCESS,
          payload: response.data.data,
        });
        setData(response.data.data.filter((item) => !item.isDeleted));
      })
      .catch((error) => {
        dispatch({ type: GET_ADDITIONAL_CHARGE_TYPE_FAILURE, payload: error });
      });
  };

  useEffect(() => {
    if (open) {
      getAdditionalChargeType();
    }
  }, [open]);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSurchargeTypeError('');
    resetSurcharge();
  };

  const handleDeletePopup = (surcharge) => {
    setDeleteSurcharge(surcharge);
    setDeletePopup(true);
  };

  const handleCloseDeletePopup = () => {
    setDeletePopup(false);
  };

  const handleRestorePopup = () => {
    setRestorePopup(true);
  };

  const handleCloseRestorePopup = () => {
    setRestorePopup(false);
  };

  const handleChangeSurChargeType = (e) => {
    if (e.target.value === "") {
      setSurchargeTypeError("Surcharge type is required");
    } else if (e.target.value.length > 70) {
      setSurchargeTypeError("Surcharge type must not be more than 70");
    } else {
      setSurchargeTypeError('');
    }
    setSurchargeType(e.target.value);
  }

  const handleAddSurcharge = async() => {
    const data = {
      name: surchargeType,
      isAWBLevel: radioValue === "jobLevel" ? false : true
    };
    if (surchargeType && surchargeType.length <= 70) {
      let isCheckSurchargeTypeExists = await checkSurchargeTypeExists(surchargeType);
      if (isCheckSurchargeTypeExists) {
        handleRestorePopup();
      } else if (isCheckSurchargeTypeExists === false) {
        addSurcharge(data);
        resetSurcharge();
      }
    } else {
      if (surchargeType === "") {
        setSurchargeTypeError("Surcharge type is required");
      } else if (surchargeType.length > 70) {
        setSurchargeTypeError("Surcharge type must not be more than 70");
      }
    }
  };

  const resetSurcharge = () => {
    setRadioValue('jobLevel');
    setSurchargeType('');
  }

  let checkSurchargeTypeExists = async (name) => {
    try {
      setIsLoading(true);
      let response = await API.post(`/surcharges/checkSurchargeExists`, { name });
      return response.data?.data;
    } catch (error) {
      toast.error(error.response.data?.message);
    } finally {
      setIsLoading(false);
    }
  }

  // API calling to add surcharge
  let addSurcharge = (value) => {
    dispatch({ type: ADD_SURCHARGE });
    API.post("surcharges", value)
      .then((response) => {
        getAdditionalChargeType();
        toast.success(response.data?.message);
        dispatch({
          type: ADD_SURCHARGE_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        toast.error(error.response.data?.message);
        dispatch({ type: ADD_SURCHARGE_FAILURE, payload: error });
      });
  };

  // API calling to edit surcharge
  let editSurcharge = (value, index) => {
    const surcharge = {
      ...value,
      isAWBLevel: !value.isAWBLevel
    }
    dispatch({ type: EDIT_SURCHARGE });
    API.put(`surcharges/${surcharge.id}`, surcharge)
      .then((response) => {
        toast.success(response.data?.message);
        dispatch({
          type: EDIT_SURCHARGE_SUCCESS,
          payload: response.data.data,
        });
        data[index] = { ...data[index], isAWBLevel: surcharge.isAWBLevel };
        setData([...data]);
      })
      .catch((error) => {
        toast.error(error.response.data?.message);
        dispatch({ type: EDIT_SURCHARGE_FAILURE, payload: error });
      });
  };

  // API calling to delete surcharge
  let deleteSurcharge = () => {
    dispatch({ type: DELETE_SURCHARGE });
    API.delete(`surcharges/${getDeleteSurcharge.id}`)
      .then((response) => {
        const tmp = data.filter(surcharge => surcharge.id != getDeleteSurcharge.id);
        setData(tmp);
        toast.success(response.data?.message);
        dispatch({
          type: DELETE_SURCHARGE_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        toast.error(error.response.data?.message);
        dispatch({ type: DELETE_SURCHARGE_FAILURE, payload: error });
      });
    setDeletePopup(false);
  };

  // API calling to restore surcharge
  let restoreSurcharge = () => {
    dispatch({ type: RESTORE_SURCHARGE });
    API.post("surcharges/restore", { name: surchargeType })
      .then((response) => {
        getAdditionalChargeType();
        toast.success(response.data?.message);
        dispatch({
          type: RESTORE_SURCHARGE_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        toast.error(error.response.data?.message);
        dispatch({ type: RESTORE_SURCHARGE_FAILURE, payload: error });
      });
    setRestorePopup(false);
  };

  return (
    <div className={classes.fuelSurchargeUpdateWrapper}>
      <Button
        className="blue-btn primary-btn"
        color="inherit"
        disableElevation
        onClick={handleClickOpen}
      >
        Surcharge Update
      </Button>

      <div className={classes.ConfirmWrapper}>
        <Dialog
          open={open}
          // scroll={scroll}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={classes.customModal}
        >
          <div className="close-modal">
            <img src={closeIcon} alt="Close" onClick={handleClose} />
          </div>
          <DialogTitle id="alert-dialog-title" className="title">
            Add Surcharge
          </DialogTitle>
          <DialogContent className="add-surcharge">
            <div className="form-row">
              <div className="form-gourp">
                <FormControl variant="outlined">
                  <label className="label-text" htmlFor="customer-name">
                    Surcharge type
                  </label>
                  <TextField
                    id="name"
                    placeholder="Surcharge type"
                    variant="outlined"
                    type="text"
                    onChange={e => handleChangeSurChargeType(e)}
                    value={surchargeType}
                    error={
                      surchargeTypeError
                    }
                    helperText={
                      surchargeTypeError
                    }
                  />
                </FormControl>
              </div>
            </div>
            <div className="div-wrapper">
              <RadioGroup
                row
                aria-label="position"
                name="position"
                defaultValue="top"
                onChange={e => setRadioValue(e.target.value)}
                value={radioValue}
              >
                <FormControlLabel
                  value="jobLevel"
                  control={<Radio color="primary" />}
                  label="Job Level"
                  labelPlacement="end"
                />
                <FormControlLabel
                  value="AWBLevel"
                  control={<Radio color="primary" />}
                  label="AWB Level"
                  labelPlacement="end"
                />
              </RadioGroup>
            </div>
          </DialogContent>
          <DialogActions className="bottom-button-block">
            <Button
              className="primary-btn gray-border-btn"
              color="inherit"
              disableElevation
              onClick={handleClose}
            >
              CANCEL
            </Button>

            <Button
              className="orange-btn primary-btn center-loading-indicator btn-add-surcharge"
              color="inherit"
              disableElevation
              onClick={handleAddSurcharge}
              disabled={state.surcharge?.addingSurcharge || isLoading}
            >
              {state.surcharge?.addingSurcharge || isLoading ? (
                <CircularProgress color="inherit" />
              ) : (
                "ADD SURCHARGE"
              )}
            </Button>
          </DialogActions>
          <div className={classes.TableWrapper}>
            <TableContainer component={Paper} className={classes.customTable}>
              <Table stickyHeader aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell className="name">Charge</TableCell>
                    <TableCell className="date">Date created</TableCell>
                    {/*<TableCell className="isAWBLevel">Charge per AWB</TableCell>*/}
                    <TableCell className="delete-link"></TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {data?.count === 0 ? (
                    <TableRow className="no-data">
                      <TableCell colSpan={4}>
                        <span>No Data Found</span>
                      </TableCell>
                    </TableRow>
                  ) : (
                    data?.map((item, index) => (
                      <TableRow key={item.id}>
                        <TableCell className="name">
                          {item.name ? item.name : "-"}
                        </TableCell>
                        <TableCell className="date">
                          {item.createdAt
                            ? utcToTimezone(
                              item.createdAt,
                              timezoneDefault,
                              "DD/MM/YYYY"
                            )
                            : "-"}
                        </TableCell>
                        {/*<TableCell className="isAWBLevel">*/}
                        {/*  <FormControlLabel*/}
                        {/*    control={*/}
                        {/*      <IOSSwitch checked={item.isAWBLevel}*/}
                        {/*        onChange={(e) => editSurcharge(item, index)}*/}
                        {/*      />*/}
                        {/*    }*/}
                        {/*  />*/}
                        {/*</TableCell>*/}
                        <TableCell className="delete-link">
                          <span
                            onClick={() => handleDeletePopup(item)}
                          >Delete</span>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Dialog>
      </div>
      <DeletePopup
        open={openDeletePopup}
        handleClose={handleCloseDeletePopup}
        handleDelete={deleteSurcharge}
        deleteUser={getDeleteSurcharge.name}
        loading={state.surcharge?.deletingSurcharge}
      />
      <div>
        <Dialog
          open={openRestorePopup}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={classes.customModalRestoreSurcharge}
        >
          <div className="close-modal">
            <img src={closeIcon} alt="Close" onClick={handleCloseRestorePopup} />
          </div>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <p>The surcharge name <b>{surchargeType}</b> has been used before and was previously deleted.</p>
              <p>Do you wish to restore this surcharge with its original settings?</p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={restoreSurcharge}
              color="primary"
              className="orange-btn primary-btn center-loading-indicator"
              disabled={state.surcharge?.restoringSurcharge}
            >
              Restore
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}

export default SurchargeUpdate;
